import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ReactComponent as ShieldCheckMark } from '../../../assets/images/common/icons/shield-check-mark.svg'
import Modal from '../Modal'
import SubmitButton from '../buttons/SubmitButton'
import classes from './SocialSettingsModal.module.scss'

const SocialSettingsModal = ({ showModal, closeModal }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      className={classes.socialSettingsModalContent}
    >
      <section className='d-flex flex-column justify-content-center align-items-center'>
        <ShieldCheckMark className={classNames(classes.shieldCheckMark, 'mt-2')} />
        <h2 className={classes.title}>{t('common.childSocialFeatureSettings.title')}</h2>
        <p className={classes.message}>
          {t('common.socialSettingsModal.messagePara1')}
          <br/><br/>
          {t('common.socialSettingsModal.messagePara2')}
        </p>
      </section>
      <main className='row py-3'>
        <div className='col-12'>
          <SubmitButton
            onClick={closeModal}
            buttonMessage={t('common.socialSettingsModal.gotIt')}
            buttonColor='orange-button'
          />
        </div>
      </main>
    </Modal>
  )
}

SocialSettingsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

export default SocialSettingsModal
